(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('mouseover', (e) => {
    const swatch = e.target.closest('.pc-swatch--card[data-img]');
    if (!swatch) return;
    const gallery = swatch.closest('.card-gallery');
    if (!gallery) return;
    const preview = gallery.querySelector('.pc-img-preview');
    if (!preview) return;
    preview.src = swatch.dataset.img;
    preview.classList.add('pc-img-preview--visible');
  });

  document.addEventListener('mouseout', (e) => {
    const swatch = e.target.closest('.pc-swatch--card[data-img]');
    if (!swatch) return;
    const gallery = swatch.closest('.card-gallery');
    if (!gallery) return;
    const preview = gallery.querySelector('.pc-img-preview');
    if (!preview) return;
    preview.classList.remove('pc-img-preview--visible');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    // Horizontal accordion: only one tab open at a time
  document.addEventListener('click', function (e) {
    const header = e.target.closest('.accordion--horizontal .details__header');
    if (!header) return;
    const thisDetails = header.closest('.details');
    const accordion = header.closest('.accordion--horizontal');
    accordion.querySelectorAll('.details[open]').forEach(function (d) {
      if (d !== thisDetails) d.removeAttribute('open');
    });
  });

  // Auto-open the first tab if none are open by default
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.accordion--horizontal').forEach(function (accordion) {
      if (!accordion.querySelector('.details[open]')) {
        const first = accordion.querySelector('.details');
        if (first) first.setAttribute('open', '');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["popup-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;
    const anchor = link.getAttribute('href').slice(1);
    if (!anchor) return;
    const dialog = document.querySelector(`dialog-component[data-popup-anchor="${anchor}"]`);
    if (!dialog) return;
    e.preventDefault();
    dialog.showDialog();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ugc-media"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ugc-media__video').forEach((video) => {
    video.muted = true;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play();
        } else {
          entry.target.pause();
        }
      });
    }, { threshold: 0.1 });
    observer.observe(video);
  });
  } catch(e) { console.error(e); }
})();

})();
